import { OverlayRef } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import { TemplateRef, Type } from '@angular/core';

export interface OverlayCloseEvent<R> {
  type: 'backdropClick' | 'close';
  data: R | undefined;
}

export class CustomOverlayRef<R = unknown, T = unknown> {
  private afterClosed$ = new Subject<OverlayCloseEvent<R>>();

  constructor(
    public overlay: OverlayRef,
    public content: string | TemplateRef<unknown> | Type<unknown>,
    public data?: T,
  ) {}

  public close(data?: R): void {
    this._close('close', data);
  }

  private _close(type: 'backdropClick' | 'close', data?: R): void {
    this.overlay.dispose();
    this.afterClosed$.next({
      type,
      data,
    });

    this.afterClosed$.complete();
  }
}
